module.exports = __webpack_public_path__ + "static/img/bg5.df0b9f2e.png";